import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, Inject, LOCALE_ID, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct, NgbModal, NgbModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import {
  catchError,
  defaultIfEmpty,
  filter,
  finalize,
  Observable,
  of,
  switchMap,
  take,
  takeUntil,
  tap,
  timer,
} from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CotizacionPausaEstado } from '../../../Models/cotizacion-pausa-estado.enum';
import { CotizacionEnvio } from '../../../Models/cotizacionEnvio';
import { CrearCotizacion } from '../../../Models/crearCotizacion';
import { DatosGenerales } from '../../../Models/datosGenerales';
import { DatosPlanes } from '../../../Models/datosPlanes';
import { NoHaySeguroEstado } from '../../../Models/no-hay-seguro-estado.enum';
import { Country } from '../../../Models/paises';
import { Planes } from '../../../Models/planes';
import { UpdateLead } from '../../../Models/updateLead';
import { UpdateResponse } from '../../../Models/updateResponse';
import { YaTenemosEstado } from '../../../Models/ya-tenemos-datos-estado.enum';
import { YaTienesPolizaEstado } from '../../../Models/ya-tienes-poliza-estado.enum';
import { BannerAppComponent } from '../../../components/banner-app/banner-app.component';
import { AutorizationModalComponent } from '../../../components/common/autorization-modal/autorization-modal.component';
import { FooterAppComponent } from '../../../components/footer-app/footer-app.component';
import { getPlanesData, getVehicleData } from '../../../helpers/dataLayerHelpers';
import {
  getFromStorage,
  getSessionId,
  saveToStorage,
  saveToStorageAndNavigate,
} from '../../../helpers/storageUtils';
import { RemainingDataFormComponent } from '../../../motos/forms/remaining-data-form/remaining-data-form.component';
import { RemainingDataFormInterface } from '../../../motos/interfaces/remainingDataForm.interface';
import {
  COTIZACION_PAUSA,
  CREAR_LEAD,
  LEAD_ERRADO,
  NO_PREPARADOS,
  POLIZA_ACTIVA,
  RESUMEN_COMPRA,
  YATEMENOSDATOS,
} from '../../../routes.constans';
import { CiudadesService } from '../../../services/Ciudades/ciudades.service';
import { CotizacionService } from '../../../services/Cotizacion/cotizacion.service';
import { DataLayerService } from '../../../services/DataLayer/data-layer.service';
import { DestinosService } from '../../../services/Destinos/destinos.service';
import { LeadsService } from '../../../services/Leads/leads.service';
import { ExceptionService } from '../../../services/excepciones/exception.service';
import { InactivityService } from '../../../services/inactivity/inactivity.service';
import { UtilsService } from '../../../services/utils.service';
import { MobilityLoaderComponent } from '../../../shared/components/mobility-loader/mobility-loader.component';
import {
  PROBLEMAS_TECNICOS_REDIRECT,
  SARLAFT_DENIED_REDIRECT,
} from '../../../shared/final-pages/final-pages.constants';
import { SarlaftResponse } from '../../../shared/interfaces/sarlaft.interface';
import { SarlaftService } from '../../../shared/services/sarlaft.service';
import { processSarlaftResponse } from '../../../shared/utils/sarlaft-utils';
import {
  loadCrearCotizacion,
  updateCotizacionResponse,
  updateCrearCotizacion,
} from '../../../storage/Cotizacion/cotizacion.action';
import { selectData } from '../../../storage/Lead/data.selectors';
import { selectPlanes } from '../../../storage/Planes/planes.selector';
import { StepperComponent } from '../stepper/stepper.component';

@Component({
  selector: 'app-datos-restantes',
  standalone: true,
  imports: [
    BannerAppComponent,
    StepperComponent,
    ReactiveFormsModule,
    NgbTypeaheadModule,
    FooterAppComponent,
    NgbModule,
    CommonModule,
    RemainingDataFormComponent,
    MobilityLoaderComponent,
  ],
  templateUrl: './datos-restantes.component.html',
  styleUrl: './datos-restantes.component.scss',
})
export class DatosRestantesComponent implements OnInit, OnDestroy {
  router = inject(Router);
  utils = inject(UtilsService);
  exceptionService = inject(ExceptionService);
  sarlaftService = inject(SarlaftService);
  destinosService = inject(DestinosService);
  inactivityService = inject(InactivityService);

  public modelSalida!: NgbDateStruct;
  citiesData: string[] = [];
  countriesStringData: string[] = [];
  countriesData: Country[] = [];

  localTimer = environment.LOCAL_TIMER;
  codAsesor = '';

  datosGenerales: DatosGenerales | null = null;
  datosGenerales$: Observable<DatosGenerales | null>;

  sessionId = '';
  public planes!: Planes;
  public planesTemp: Planes | undefined;

  leadId = ''; // ID del lead para el puller de SARLAFT
  private quoteId = ''; // ID de la cotización para navegación a resumen
  isLoading = false;

  private readonly POLLING_INTERVAL_MS = 10000; // 10 segundos
  private readonly POLLING_TIMEOUT_MS = 60000; // 1 minuto

  constructor(
    private ciudadesServices: CiudadesService,
    private route: ActivatedRoute,
    @Inject(LOCALE_ID) public locale: string,
    private store: Store,
    private leadServices: LeadsService,
    private modalService: NgbModal,
    private cotizacionService: CotizacionService,
    private dataLayerService: DataLayerService,
  ) {
    this.datosGenerales$ = this.store.select(selectData);
    this.datosPlanes$ = this.store.select(selectPlanes);

    // Get codigoAsesor from query parameters
    this.route.queryParams.subscribe((params) => {
      this.codAsesor = params['codigoAsesor'] || '';
    });
  }

  dataCrearCotizacion: CrearCotizacion = {
    CotizacionEnvio: {
      selected_plan: '',
      lead_id: '',
      payment_frequency: '',
      zona_circulacion: '',
      coberturasOpcionales: [],
    },
    Cotizacion: {
      data: {
        asset: {
          brand: '',
          cylinder: '',
          model: '',
          owner: {
            address: {
              city: '',
              country: '',
              department: '',
              street: '',
            },
            document: {
              number: '',
              type: '',
            },
            fullname: '',
          },
          plate: '',
        },
        plan: {
          price: {
            full: {
              currency: '',
              amount: 0,
              formatted: '',
            },
          },
          selected: {
            Selected: '',
          },
        },
        pre_policy_number: '',
        quote_id: '',
      },
    },
  };

  cotizacionEnvio: CotizacionEnvio = {
    selected_plan: '',
    lead_id: '',
    payment_frequency: '',
    zona_circulacion: '',
    coberturasOpcionales: [],
  };

  datosPlanes: DatosPlanes | null = null;
  datosPlanes$: Observable<DatosPlanes | null>;
  updateResponse: UpdateResponse | null = null;

  datosPlanesEnvio: DatosPlanes = {
    lead_id: '',
    planes: {
      data: {
        products: [
          {
            coveragesGroup: [
              {
                Name: '',
                Include: false,
                Description: '',
              },
            ],
            coverages: [
              {
                price: 0,
                description: '',
                name: '',
              },
            ],
            order: 1,
            code: '',
            priceMensual: {
              currency: '',
              amount: 0,
              formatted: '',
            },
            priceAnual: {
              currency: '',
              amount: 0,
              formatted: '',
            },
            name: '',
          },
        ],
      },
      FalloTarifaEsencialMotos: false,
      FalloTarifaTotalMotos: false,
    },
    payment_frequency: '',
    selected_plan: '',
    coberturasOpcionales: [],
  };

  ngOnInit(): void {
    this.localTimer = environment.LOCAL_TIMER;
    this.sessionId = getSessionId().toString();

    this.datosGenerales$.subscribe((data) => {
      this.datosGenerales = data;
    });

    this.datosPlanes$.subscribe((data) => {
      if (data) {
        this.datosPlanesEnvio = data;
      }
      this.planesTemp = data?.planes;
    });

    if (this.planesTemp) {
      this.planes = this.planesTemp;
    }

    this.dataLayerService.pushDataLayer({
      event: 'moto_ecommerce_step_4_datos_cliente',
      ecom_tipo: 'Moto',
      ecom_item: 'Pageview',
      ecom_pantalla: 'Datos Cliente',
      user_id: this.sessionId,
      ...getVehicleData(this.datosGenerales),
      ...getPlanesData(this.datosPlanesEnvio),
    });

    // Iniciar timer de inactividad con el nuevo servicio
    this.inactivityService.startDefaultTimerForScreen(
      'Datos-Dueño-pagador',
      'Abandono Datos dueño y pagador',
      '70',
      () => this.saveFormBeforePause(),
    );

    this.destinosService.getDestinos(this.sessionId).subscribe((data) => {
      if (data !== undefined) {
        {
          console.log('data', data);
        }
        const citiesLabels = data.data?.circulation_zones.map((itemZonas) => itemZonas.label);
        this.citiesData = [...citiesLabels];
      }
    });

    this.ciudadesServices.getPaises(this.sessionId).subscribe((data) => {
      if (data !== undefined) {
        this.countriesData = data.data.countries;
        const countriesLabels = data.data.countries.map((itemPaises) => itemPaises.label);
        this.countriesStringData = [...countriesLabels];
      }
    });

    // Suscribirse al store para actualizar el servicio con datos del lead
    this.datosGenerales$.subscribe((data) => {
      if (data) {
        this.inactivityService.setLeadData(data);
      }
    });
  }

  Validaciones(formData: RemainingDataFormInterface) {
    this.isLoading = true;
    this.actualizaLead(formData);
    this.dataLayerService.pushDataLayer({
      event: 'moto_ecommerce_step_4_datos_cliente',
      ecom_tipo: 'Moto',
      ecom_item: 'Button',
      ecom_subitem: 'Continuar',
      ecom_pantalla: 'Datos Cliente',
      user_id: this.sessionId,
      ...getVehicleData(this.datosGenerales),
      ...getPlanesData(this.datosPlanesEnvio),
      dueño_paga_seguro: formData.isPayer ? 'Si' : 'No',
    });
  }

  @ViewChild(RemainingDataFormComponent) remainingFormComp!: RemainingDataFormComponent;

  saveFormBeforePause(): void {
    // Guardar siempre, incluso si el formulario no está dirty (puede tener datos pre-llenados)
    const formValue = this.remainingFormComp?.remainingDataForm?.value;

    if (formValue) {
      console.log('💾 Guardando datos antes de pausa por inactividad...');

      // Guardar en session storage para recuperación local
      saveToStorage('remainingDataForm', formValue, 'session');

      // Mapear y actualizar en backend con porcentaje de avance
      const leadUpdate = this.mapFormToUpdateLead(formValue);
      leadUpdate.progressPercent = '70'; // Marcar el avance al 80% (Datos-Restantes)

      this.leadServices
        .actualizarLead(leadUpdate, this.sessionId, this.datosGenerales?.LeadResponse.data.Id || '')
        .subscribe({
          next: (data) => console.log('✅ Lead actualizado exitosamente antes de pausa'),
          error: (err) => console.error('❌ Error al guardar datos antes de pausa:', err),
        });
    }
  }

  private mapFormToUpdateLead(formData: RemainingDataFormInterface): UpdateLead {
    // Validar y parsear ciudad (formato esperado: "ciudad - departamento")
    const seleccion =
      formData.city && formData.city.includes('-') ? formData.city.split('-') : ['', ''];
    const cityId = seleccion[0]?.trim() || '';
    const departmentId = seleccion[1]?.trim() || '';

    const countrySelected = this.countriesData.find(
      (country) => country.label === formData.country,
    )?.value;
    const payerCountrySelected = this.countriesData.find(
      (country) => country.label === formData.payerCountry,
    )?.value;
    const formCountryValue = formData.isPayer === 'Y' ? countrySelected : payerCountrySelected;

    // Validar y parsear ciudad del pagador
    const payerSeleccion =
      formData.payerCity && formData.payerCity.includes('-')
        ? formData.payerCity.split('-')
        : seleccion;
    const payerCityId = payerSeleccion[0]?.trim() || '';
    const payerDepartmentId = payerSeleccion[1]?.trim() || '';

    const savedForm = getFromStorage<RemainingDataFormInterface>('remainingDataForm', 'session');

    const resolvedBornDate =
      formData.bornDate ||
      savedForm?.bornDate ||
      this.datosGenerales?.LeadResponse?.data?.lead?.owner_borndate ||
      '';

    return {
      lead_id: this.datosGenerales?.LeadResponse.data.Id || '',
      born_date: resolvedBornDate,
      phone: formData.number || '',
      email: formData.email || '',
      accept_tos: true,
      document: {
        issued: formData.expeditionDate || '',
        number: '',
      },
      address: {
        country: formData.country || '',
        department_id: departmentId,
        street: formData.address || '',
        city_id: cityId,
      },
      payer: {
        firstname: formData.payerFirstName?.toUpperCase(),
        surname: formData.payerSecondName?.toUpperCase(),
        lastname: formData.payerFirstLastName?.toUpperCase(),
        mothername: formData.payerSecondLastName?.toUpperCase(),
        born_date: formData.payerBornDate || formData.bornDate || '',
        phone: formData.payerNumber || formData.number || '',
        email: formData.payerEmail || formData.email || '',
        document: {
          issued: formData.payerExpeditionDate || formData.expeditionDate || '',
          type: formData.payerIdentificationType || '',
          number: formData.payerDocument || '',
        },
        residency_address: {
          street: formData.payerAddress || formData.address || '',
          city_id: payerCityId,
          department_id: payerDepartmentId,
          country: formCountryValue || 'CO',
        },
      },
      firstname: '',
      lastname: '',
      surname: '',
      mothername: '',
      prendario: '',
    };
  }

  actualizaLead(formData: RemainingDataFormInterface) {
    const leadUpdate = this.mapFormToUpdateLead(formData);

    this.leadServices
      .actualizarLead(leadUpdate, this.sessionId, this.datosGenerales?.LeadResponse.data.Id || '')
      .subscribe(
        (data) => {
          this.updateResponse = data;
          this.Cotizar(formData);
        },
        (error) => {
          console.error('Error al actualizar lead:', error);
          this.handleLeadUpdateError();
        },
      );
  }

  Cotizar(formData: RemainingDataFormInterface) {
    this.cotizacionEnvio.selected_plan = this.datosPlanesEnvio.selected_plan;
    this.cotizacionEnvio.lead_id = this.datosGenerales?.LeadResponse.data.Id || '';
    this.cotizacionEnvio.payment_frequency = this.datosPlanesEnvio.payment_frequency;
    this.cotizacionEnvio.zona_circulacion = this.updateResponse?.data.zonaCirculacion || '';
    // La cobertura opcional elegida en /planes debe viajar tambien a la cotizacion
    this.cotizacionEnvio.coberturasOpcionales = this.datosPlanesEnvio.coberturasOpcionales ?? [];

    this.dataCrearCotizacion.CotizacionEnvio = this.cotizacionEnvio;
    this.store.dispatch(loadCrearCotizacion({ data: this.dataCrearCotizacion }));

    this.cotizacionService.postCrearCotizacion(this.cotizacionEnvio, this.sessionId).subscribe(
      (data) => {
        const dCotizacion: CrearCotizacion = {
          CotizacionEnvio: this.cotizacionEnvio,
          Cotizacion: {
            ...data,
          },
        };

        this.store.dispatch(updateCotizacionResponse({ CotizacionResp: data }));
        ((dCotizacion.dueño_paga_seguro = formData.isPayer ? 'Si' : 'No'),
          this.store.dispatch(updateCrearCotizacion({ upCrearCotizacion: dCotizacion })));
        const queryParams = this.codAsesor ? { codigoAsesor: this.codAsesor } : {};
        // this.router.navigate([NO_ES_SOAT], { queryParams });

        this.quoteId = data.data.quote_id;
        this.startSarlaftCheck(this.sessionId, data.data.quote_id);
      },
      (error) => {
        console.log('DATOS_RESTANTES_ERROR: ', error);
        this.handleCotizacionError(error);
      },
    );
  }

  openModal() {
    const modalRef = this.modalService.open(AutorizationModalComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.title = 'Política de privacidad y Tratamiento de datos personales';

    modalRef.componentInstance.close.subscribe(() => {
      modalRef.close();
    });
  }

  public startSarlaftCheck(sessionId: string, recordId: string) {
    // Obtener y guardar el leadId del Store para usarlo en el puller
    this.leadId = this.datosGenerales?.LeadResponse?.data?.Id || '';
    console.log('🔍 Iniciando SARLAFT check con recordId:', recordId, 'leadId:', this.leadId);

    this.sarlaftService
      .sarlaftEvaluation(sessionId, recordId)
      .pipe(
        // Usamos catchError para atrapar errores 4XX y 5XX
        catchError((error: HttpErrorResponse) => {
          // Ahora sí podemos procesar el error
          this.handleSarlaftResult(null, error);
          // Devolvemos un observable que no emite nada para que la cadena no se rompa
          return of(null);
        }),
        finalize(() => {
          // Ojo: isLoading se gestiona dentro de handleSarlaftResult
          // porque el polling puede mantener el proceso activo.
        }),
      )
      .subscribe((response) => {
        // Este bloque solo se ejecuta para respuestas 2XX
        if (response) {
          this.handleSarlaftResult(response, null);
        }
      });
  }

  // ÚNICO método que procesa la lógica y decide qué hacer
  private async handleSarlaftResult(
    response: SarlaftResponse | null,
    error: HttpErrorResponse | null,
  ) {
    const decision = await processSarlaftResponse(response, error);

    if (!decision) {
      this.isLoading = false;
      return;
    }

    // Si la decisión requiere actualizar el lead, lo hacemos
    if (decision.action === 'UPDATE_LEAD') {
      this.sendSarlaftException(
        decision.leadProspect,
        decision.leadPercentage,
        decision.estadoRetoma,
        decision.estadoRescate,
        decision.leadStatus,
      );
    }

    // Si la decisión requiere iniciar el polling
    if (decision.action === 'START_PULLER' && response) {
      console.log('Respuesta inicial indica polling. Redirigiendo y comenzando sondeo...');
      // Primero actualizamos el lead y redirigimos (según reglas 6 y 8)
      this.initiatePolling(response); // Pasamos la respuesta inicial al puller
      return; // El polling se encargará del resto
    }

    // Para todos los demás casos, detenemos la carga y navegamos
    this.isLoading = false;

    // Si navega a resumen_compra, pasar prepolicyid para que cargue datos completos vía API
    if (this.quoteId && decision.redirectPath.includes(RESUMEN_COMPRA)) {
      const queryParams: Record<string, string> = { prepolicyid: btoa(this.quoteId) };
      if (this.codAsesor) {
        queryParams['codigoAsesor'] = this.codAsesor;
      }
      this.router.navigate(decision.redirectPath, { queryParams });
    } else {
      this.router.navigate(decision.redirectPath);
    }
  }

  // Lógica de polling correcta y controlada
  private initiatePolling(initialResponse: SarlaftResponse) {
    const stopPolling$ = timer(this.POLLING_TIMEOUT_MS);
    //Objeto único para identificar el timeout de forma segura
    const TIMEOUT_VALUE = { timeout: true };

    timer(this.POLLING_INTERVAL_MS, this.POLLING_INTERVAL_MS)
      .pipe(
        // El polling se detiene por el timeout
        takeUntil(stopPolling$),
        // En cada intervalo, llamamos al servicio de puller con el leadId
        switchMap(() => this.sarlaftService.pullerEvaluation(this.sessionId, this.leadId)),
        // Log para depuración
        tap((pullerResponse) =>
          console.log('Respuesta del puller:', pullerResponse.data.sarlaftEvaluation),
        ),
        // Filtramos para seguir solo si la respuesta sigue pendiente
        filter((pullerResponse) => pullerResponse.data.sarlaftEvaluation !== 'ESPERA DE WEBHOOK'),
        // Tomamos la PRIMERA respuesta que no esté pendiente y completamos el stream
        take(1),
        // Si el flujo se completa vacío (por timeout), emite TIMEOUT_VALUE.
        defaultIfEmpty(TIMEOUT_VALUE),
        catchError((error: HttpErrorResponse) => {
          // Si el puller falla, lo manejamos y detenemos el flujo
          console.error('Error durante el polling', error);
          this.handleSarlaftResult(null, error);
          return of(null);
        }),
        finalize(() => console.log('Polling finalizado.')),
      )
      .subscribe(async (finalResponse) => {
        console.log('subscribe finalResponse:', finalResponse);
        // 1. Caso: Timeout
        if (finalResponse && 'timeout' in finalResponse && finalResponse.timeout === true) {
          console.warn('Polling time-out. No se recibió respuesta definitiva.');
          this.isLoading = false;
          // Redirige a la página específica de timeout.
          saveToStorage('ya_tenemos_tus_datos', YaTenemosEstado.LEAD_ABANDONO_RESUMEN, 'session'); // VERIFICAR
          this.router.navigate([YATEMENOSDATOS]);
        }
        // 2. Caso: Respuesta exitosa del puller
        else if (finalResponse) {
          // Procesamos la respuesta final obtenida del puller
          await this.handleSarlaftResult(finalResponse as SarlaftResponse, null);
        } else {
          // Esto se ejecuta si el polling termina por timeout sin una respuesta definitiva
          console.warn('Polling time-out. No se recibió respuesta definitiva.');
          // Aquí podrías redirigir a una pantalla de "intente más tarde"
          this.isLoading = false;
          saveToStorage('ya_tenemos_tus_datos', YaTenemosEstado.LEAD_ABANDONO_RESUMEN, 'session'); // VERIFICAR
          this.router.navigate([YATEMENOSDATOS]);
        }
      });
  }

  private sendSarlaftException(
    leadProspect: string | undefined,
    leadPercentage: string | undefined,
    estadoRetoma?: 'Habilitado' | 'Inhabilitado',
    estadoRescate?: 'Habilitado' | 'Inhabilitado',
    leadStatus?: string,
  ) {
    const leadId = this.datosGenerales?.LeadResponse.data.Id || '';

    const exceptionPayload = {
      required_status: leadProspect || '',
      percentege_lead: Number(leadPercentage) || 80,
      product: 'Motos Digital',
      estadoRetoma: estadoRetoma,
      estadoRescate: estadoRescate,
      Leadstatus: leadStatus,
      session_id: this.sessionId,
    };

    console.log('📤 Enviando excepción SARLAFT:', exceptionPayload);

    this.exceptionService.sendGeneralException(this.sessionId, leadId, exceptionPayload).subscribe({
      next: (response) => {
        console.log('✅ Excepción SARLAFT enviada:', response);
        console.log('📊 Estados enviados - Retoma:', estadoRetoma, 'Rescate:', estadoRescate);
        if (leadStatus) {
          console.log('📊 Leadstatus enviado:', leadStatus);
        }
      },
      error: (err) => {
        console.error('❌ Error al enviar excepción SARLAFT:', err);
      },
    });
  }

  private async handleCotizacionError(error: any): Promise<void> {
    try {
      switch (error.status) {
        case 422:
          const dataError = JSON.parse(error.error.message);

          await this.handleError422(dataError);
          break;
        case 406:
          await saveToStorageAndNavigate(
            'cotizacion_pausa_estado',
            CotizacionPausaEstado.FALLA_TECNICA_COTIZADOR,
            this.router,
            [COTIZACION_PAUSA],
          );
          break;
        case 500:
          await saveToStorageAndNavigate(
            'cotizacion_pausa_estado',
            CotizacionPausaEstado.FALLA_TECNICA_COTIZADOR,
            this.router,
            [COTIZACION_PAUSA],
          );
          break;
        default:
          // Manejar otros errores si es necesario
          console.error('Error no manejado:', error);
          break;
      }
    } catch (storageError) {
      console.error('Error al guardar en storage:', storageError);
      // Aún así navegamos para no bloquear la aplicación
      this.router.navigate([LEAD_ERRADO]);
    }
  }

  private async handleError422(dataError: any): Promise<void> {
    const message = dataError.data.message;

    switch (message) {
      case 'Fecha de Nacimiento del dueño es incorrecta':
        await saveToStorageAndNavigate(
          'cotizacion_pausa_estado',
          CotizacionPausaEstado.LEAD_USO_COMERCIAL,
          this.router,
          [COTIZACION_PAUSA],
        );
        break;

      case 'Zona de Circulacion no valida':
        await saveToStorageAndNavigate(
          'no_hay_seguro_estado',
          NoHaySeguroEstado.ZONA_CIRCULACION,
          this.router,
          [NO_PREPARADOS],
        );
        break;

      case 'No se aprobo la validacion de riesgos':
        await saveToStorageAndNavigate(
          'no_hay_seguro_estado',
          NoHaySeguroEstado.RIESGOS_CONSULTABLES,
          this.router,
          [SARLAFT_DENIED_REDIRECT],
        );
        break;

      case 'No hay datos de propietario actual.':
        await saveToStorageAndNavigate(
          'cotizacion_pausa_estado',
          CotizacionPausaEstado.LEAD_USO_COMERCIAL,
          this.router,
          [COTIZACION_PAUSA],
        );
        break;

      case 'No pasa validación de cilindraje, valor asegurado y modelo':
        await saveToStorageAndNavigate(
          'cotizacion_pausa_estado',
          CotizacionPausaEstado.LEAD_USO_COMERCIAL,
          this.router,
          [COTIZACION_PAUSA],
        );
        break;

      case 'No pasa Politica de Linea Permitida':
        await saveToStorageAndNavigate(
          'no_hay_seguro_estado',
          NoHaySeguroEstado.MARCA_LINEA_NO_PERMITIDA,
          this.router,
          [NO_PREPARADOS],
        );
        break;

      case 'No pasa validación de movilidad':
        await saveToStorageAndNavigate(
          'cotizacion_pausa_estado',
          CotizacionPausaEstado.LEAD_USO_COMERCIAL,
          this.router,
          [COTIZACION_PAUSA],
        );
        break;

      case 'Hubo problemas para comunicarse con el servicio de Runt':
        await saveToStorageAndNavigate(
          'cotizacion_pausa_estado',
          CotizacionPausaEstado.LEAD_FALLA_RUNT,
          this.router,
          [LEAD_ERRADO],
        );
        break;

      case 'Hubo problemas para comunicarse con el servicio de Fasecolda':
        await saveToStorageAndNavigate(
          'cotizacion_pausa_estado',
          CotizacionPausaEstado.LEAD_FALLA_SERVICIO_FASECOLDA,
          this.router,
          [COTIZACION_PAUSA],
        );
        break;

      case 'No se aprobó la validación de Prenda':
        this.router.navigate([CREAR_LEAD]);
        break;

      case 'No se aprobo validación de cumulo':
        await saveToStorageAndNavigate(
          'ya_tienes_una_poliza_activa',
          YaTienesPolizaEstado.YA_TIENES_POLIZA_ACTIVA,
          this.router,
          [POLIZA_ACTIVA],
        );
        break;

      case 'Error Servidor Consulta Riesgos':
        await saveToStorageAndNavigate(
          'ya_tienes_una_poliza_activa',
          NoHaySeguroEstado.RIESGOS_CONSULTABLES,
          this.router,
          [PROBLEMAS_TECNICOS_REDIRECT],
        );
        break;

      default:
        console.error('Mensaje de error 422 no manejado:', message);
        await saveToStorageAndNavigate(
          'cotizacion_pausa_estado',
          CotizacionPausaEstado.FALLA_TECNICA_COTIZADOR,
          this.router,
          [COTIZACION_PAUSA],
        );
        break;
    }
  }

  private async handleLeadUpdateError(): Promise<void> {
    await saveToStorageAndNavigate(
      'cotizacion_pausa_estado',
      CotizacionPausaEstado.LEAD_FALLA_RUNT,
      this.router,
      [LEAD_ERRADO],
    );
  }

  ngOnDestroy() {
    this.inactivityService.stopTimer();
  }
}
